module.exports = "/_next/static/images/c77268e82bd1d9ff40d431acbdff6eed-two-people-looking-lg@2x.jpg";